import React from 'react'

import type { CompactCampaignBannerHeaderContentBlock } from '@library/api-menu-experience'
import { CompactCampaignBanner } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { useMenuExperienceCategoryNavigation } from '../menuExperienceNavigationContext'

type CompactCampaignBannerContentBlockWrapperProps = {
  contentBlock: CompactCampaignBannerHeaderContentBlock
}

const onAddClick = () => {}
const onBlockedAddAttempt = () => {}
const onRecipeClick = () => {}
const onRemoveClick = () => {}

const getRecipeCardState =
  (contentBlock: CompactCampaignBannerHeaderContentBlock) => (recipeId: RecipeUUID) => {
    const recipe = contentBlock.items.find((item) => item.id === recipeId)

    return {
      isInBasket: false,
      isOutOfStock: recipe ? !recipe.isAvailable : false,
    }
  }

export const CompactCampaignBannerContentBlockWrapper = ({
  contentBlock,
}: CompactCampaignBannerContentBlockWrapperProps) => {
  const { selectCategory } = useMenuExperienceCategoryNavigation()

  const onCtaClick = (targetCategory: { id: string; slug: string }) => {
    selectCategory(targetCategory, 'merch_banner', undefined, {
      merch_header_type: contentBlock.type,
    })
  }

  return (
    <CompactCampaignBanner
      contentBlock={contentBlock}
      getRecipeCardState={getRecipeCardState(contentBlock)}
      canAddRecipes={true}
      reachedLimit={false}
      onAddClick={onAddClick}
      onBlockedAddAttempt={onBlockedAddAttempt}
      onCtaClick={onCtaClick}
      onRecipeClick={onRecipeClick}
      onRemoveClick={onRemoveClick}
    />
  )
}
